import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { hot } from 'react-hot-loader';

export default hot(module)(function AlertContainer(props) {
	return (
		<Snackbar autoHideDuration={6000} onClose={props.onClose} open={props.show}>
			<MuiAlert elevation={6} onClose={props.onClose} severity={props.severity} variant="filled">
				{props.message}
			</MuiAlert>
		</Snackbar>
	);
});
